import React from "react";
import { get } from "lodash";
import PropTypes from "prop-types";
import { H1 } from "orcs-design-system";
import GroupPropType from "src/custom-prop-types/group";

import { useWorkspace } from "src/contexts/global/WorkspaceContext";

import TeamNameEditor from "./TeamNameEditorContainer";

const TeamName = ({ team, color = "white" }) => {
  const {
    config: { groupTypes },
  } = useWorkspace();

  const { type, name, isDeleted, isHidden } = team;
  const canRename =
    get(groupTypes[type], "canRename", false) && !isDeleted && !isHidden;

  if (!canRename) {
    if (isDeleted || isHidden) {
      return (
        <H1
          color={color}
          fontWeight="600"
          fontSize="2.4rem"
          className="guided-tour-team-details-team-name"
        >
          <strike>{name}</strike>
        </H1>
      );
    }
    return (
      <H1
        color={color}
        fontWeight="600"
        fontSize="2.4rem"
        className="guided-tour-team-details-team-name"
      >
        {name}
      </H1>
    );
  }

  return <TeamNameEditor team={team} color={color} />;
};

TeamName.propTypes = {
  team: GroupPropType.isRequired,
  color: PropTypes.string,
};

export default TeamName;
